module.exports = __webpack_public_path__ + "img/PXL_20230523_142255462.6c37b8ca.jpg";